import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router";
import SimRegistrationPage from "./components/SimRegistrationPage";
import InactivityHandler from "./utils/InactivityHandler";
import InactivityPage from "./components/InactivityPage";
import { AuthProvider } from "./context/authContext";
import { OnboardingDataProvider } from "./context/OnboardingDataContext";
import ScrollToTop from "./components/ScrollToTop";
import MainLayout from "./components/MainLayout";
import { ErrorModalProvider } from "./context/ErrorModalContext";
import ErrorModal from "./components/ErrorModal";
import DecryptionHandler from "./utils/DecryptionHandler";
import NavigationProtection from "./utils/NavigationProtection";
import ErrorPage from "./components/ErrorPage";
import ErrorBoundary from "./components/ErrorBoundary";
import { useLazyGTM } from "./hooks/useLazyGTM";

const StepOne = lazy(() => import("./components/step_one/StepOne"));
const StepTwo = lazy(() => import("./components/step_two/StepTwo"));
const StepThree = lazy(() => import("./components/step_three/StepThree"));
const StepFour = lazy(() => import("./components/step_four/StepFour"));
const StepFive = lazy(() => import("./components/step_five/StepFive"));
const StepSix = lazy(() => import("./components/step_six/StepSix"));
const Success = lazy(() => import("./components/step_six/Success"));
const StepSixError = lazy(() => import("./components/step_six/StepSixError"));
const UpdateSCRWelcome = lazy(() => import("./components/update_scr/UpdateSCRWelcome"));
const UpdateSCRSelfieCapture = lazy(() => import("./components/update_scr/UpdateSCRSelfieCapture"));
const UpdateSCRPersonalInfo = lazy(() => import("./components/update_scr/UpdateSCRPersonalInfo"));
const UpdateSCRDocumentScan = lazy(() => import("./components/update_scr/UpdateSCRDocumentScan"));
const CHOWWelcome = lazy(() => import("./components/change_of_ownership/CHOWWelcome"));
const CHOWNewAssigneeInfo = lazy(() => import("./components/change_of_ownership/CHOWNewAssigneeInfo"));
const FlowErrorPage = lazy(() => import("./components/FlowErrorPage"));
const CHOWSelfieCapture = lazy(() => import("./components/change_of_ownership/CHOWSelfieCapture"));

function App() {
  useLazyGTM();

  return (
    <ErrorBoundary>
      <AuthProvider>
        <OnboardingDataProvider>
          <ErrorModalProvider>
            <Router>
              <ScrollToTop />
              {/* <InactivityHandler /> */}
              <NavigationProtection />
              <MainLayout>
                <Suspense fallback={<div></div>}>
                  <Routes>
                    <Route path="/" element={<DecryptionHandler />} />
                    <Route
                      path="/digital-onboarding"
                      element={<SimRegistrationPage />}
                    />
                    <Route
                      path="/globe_digital_onboarding"
                      element={<DecryptionHandler />}
                    />
                    <Route
                      path="/digital-onboarding/step-one"
                      element={<StepOne />}
                    />
                    <Route
                      path="/digital-onboarding/step-two"
                      element={<StepTwo />}
                    />
                    <Route
                      path="/digital-onboarding/step-three"
                      element={<StepThree />}
                    />
                    <Route
                      path="/digital-onboarding/step-four"
                      element={<StepFour />}
                    />
                    <Route
                      path="/digital-onboarding/step-five"
                      element={<StepFive />}
                    />
                    <Route
                      path="/digital-onboarding/step-six"
                      element={<StepSix />}
                    />
                    <Route
                      path="/digital-onboarding/simreg/success"
                      element={<Success />}
                    />
                    <Route
                      path="/digital-onboarding/registration-fail"
                      element={<StepSixError />}
                    />
                    <Route
                      path="/digital-onboarding/session-timeout"
                      element={<InactivityPage />}
                    />
                    <Route
                      path="/digital-onboarding/update-scr/welcome"
                      element={<UpdateSCRWelcome />}
                    />
                    <Route
                      path="/digital-onboarding/update-scr/selfie"
                      element={<UpdateSCRSelfieCapture />}
                    />
                    <Route
                      path="/digital-onboarding/update-scr/personal-info"
                      element={<UpdateSCRPersonalInfo />}
                    />
                    <Route
                      path="/digital-onboarding/update-scr/document"
                      element={<UpdateSCRDocumentScan />}
                    />
                    <Route
                      path="/digital-onboarding/chow/welcome"
                      element={<CHOWWelcome />}
                    />
                    <Route
                      path="/digital-onboarding/chow/scan-selfie"
                      element={<CHOWSelfieCapture />}
                    />
<Route
                      path="/digital-onboarding/chow/new-assignee-info"
                      element={<CHOWNewAssigneeInfo />}
                    />
                    <Route path="/digital-onboarding/error" element={<FlowErrorPage />} />
                    <Route path="/error" element={<ErrorPage />} />
                    <Route
                      path="*"
                      element={<Navigate to="/digital-onboarding" replace />}
                    />
                  </Routes>
                </Suspense>
                <ErrorModal />
              </MainLayout>
            </Router>
          </ErrorModalProvider>
        </OnboardingDataProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
